import { CSSProperties, SxProps } from '@mui/material';

import { Breakpoints } from '@/common/theme/constants';

export const localizedLinkStyles: CSSProperties = {
  textDecoration: 'none',
  position: 'relative',
  zIndex: 2,
  height: 'fit-content',
};

export const underlineStyles = ({
  isHovering,
  isActive,
}: {
  isHovering: boolean;
  isActive: boolean;
}): SxProps => ({
  position: 'absolute',
  zIndex: '-1',
  bottom: '30px',
  left: 0,
  height: '12px',
  transform: 'rotate(-3deg)',
  width: isHovering || isActive ? '100%' : '0',
  transition: 'all .2s ease-in-out',

  [`@media screen and (min-width: ${Breakpoints.sm}px)`]: {
    bottom: '5px',
  },
});

export const localizedLinkWrapperStyles: SxProps = {
  position: 'relative',
};
